var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingSection4Card2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FEBA05",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.5749H26.55C25.55 28.5749 24.6 28.9624 23.9 29.6624L21.7625 31.775C20.7875 32.7375 19.2 32.7375 18.225 31.775L16.0875 29.6624C15.3875 28.9624 14.425 28.5749 13.4375 28.5749H12.5C10.425 28.5749 8.75 26.9125 8.75 24.8625V11.2249C8.75 9.17491 10.425 7.51245 12.5 7.51245H27.5C29.575 7.51245 31.25 9.17491 31.25 11.2249V24.8625C31.25 26.9 29.575 28.5749 27.5 28.5749Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.4502C13.75 15.2877 14.7 14.3376 15.8625 14.3376C17.025 14.3376 17.975 15.2877 17.975 16.4502C17.975 18.8002 14.6375 19.0502 13.9 21.2877C13.75 21.7502 14.1375 22.2127 14.625 22.2127H17.975",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0502 22.2001V15.0626C25.0502 14.7376 24.8377 14.4501 24.5252 14.3626C24.2127 14.2751 23.8752 14.4001 23.7002 14.6751C22.8002 16.1251 21.8252 17.7751 20.9752 19.2251C20.8377 19.4626 20.8377 19.7751 20.9752 20.0126C21.1127 20.2501 21.3752 20.4 21.6627 20.4H26.2502",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSection4Card2);
export default __webpack_public_path__ + "static/media/landing_section4_card2.3502d02f3c967e0a3bb4bfb6785bcc89.svg";
export { ForwardRef as ReactComponent };